/**
 * Display trigger configuration keys in chips
 */

import {toast} from '@wandb/weave/common/components/elements/Toast';
import {MOON_600, THEME} from '@wandb/weave/common/css/globals.styles';
import {Icon, IconCopy} from '@wandb/weave/components/Icon';
import copyToClipboard from 'copy-to-clipboard';
import React from 'react';
import styled from 'styled-components';

const StyledConfigPill = styled.div`
  display: inline-flex;
  height: 24px;
  border-radius: 4px;
  padding: 4px 6px 4px 8px;
  align-items: center;
  background-color: light-dark(
    color-mix(in srgb, var(--moon-500) 14%, transparent),
    color-mix(in srgb, var(--moon-500) 14%, transparent)
  );
  color: light-dark(${MOON_600}, ${THEME.textSecondary});
`;
StyledConfigPill.displayName = 'S.StyledConfigPill';

const StyledConfigKey = styled.div`
  font-size: 13px;
  line-height: 16px;
  margin-right: 8px;
  font-family: 'Source Code Pro';
  font-weight: 400;
  letter-spacing: -0.05em;
`;
StyledConfigKey.displayName = 'S.StyledConfigKey';

const StyledConfigKeyButton = styled(StyledConfigKey)`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
`;
StyledConfigKeyButton.displayName = 'S.StyledConfigKeyButton';

const IconConfigKey = styled(IconCopy)`
  width: 13px;
  height: 13px;
  margin-left: 2px;
  cursor: pointer;
`;
IconConfigKey.displayName = 'S.IconConfigKey';

const IconPlusButton = styled(Icon)`
  width: 13px;
  height: 13px;
  margin-left: 0px;
  margin-right: 2px;
  cursor: pointer;
`;
IconPlusButton.displayName = 'S.IconPlusButton';

export const ConfigKey = ({
  configKey,
  onPlusClick,
}: {
  configKey: string;
  onPlusClick?: () => void;
}) => {
  const copyConfigKey = React.useCallback((val: string) => {
    copyToClipboard(val);
    toast(`Copied ${val} to clipboard`);
  }, []);
  return (
    <StyledConfigPill>
      {onPlusClick ? (
        <StyledConfigKeyButton
          as="button"
          type="button"
          aria-label={`Insert ${configKey}`}
          onClick={onPlusClick}>
          {configKey}
        </StyledConfigKeyButton>
      ) : (
        <StyledConfigKey>{configKey}</StyledConfigKey>
      )}
      {onPlusClick && <IconPlusButton name="add-new" onClick={onPlusClick} />}
      <IconConfigKey onClick={() => copyConfigKey(`"${configKey}"`)} />
    </StyledConfigPill>
  );
};
